export default __webpack_public_path__ + "static/media/arrow_back.eac6fd66.svg";